import React,{useState} from 'react';

import ReactJkMusicPlayer from 'react-jinke-music-player';
import 'react-jinke-music-player/assets/index.css';

import Button from 'react-bootstrap/Button';

import algoliasearch from 'algoliasearch/lite';
import { InstantSearch,Hits,connectSearchBox } from 'react-instantsearch-dom';

import {useSelector,useDispatch} from 'react-redux';
import {AddSong,RemoveSong} from './redux/Actions';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const searchClient = algoliasearch(
  'VZ4XUHLY9F',
  '11b8057d1c32deb8a48d19c9e1574b51'
);

const SearchBox = ({ currentRefinement, isSearchStalled, refine }) => (
  <form noValidate action="" role="search">
    <input
      type="search"
      className="inputsearch"
      placeholder="search..."
      value={currentRefinement}
      onChange={event => refine(event.currentTarget.value)}
    />
    {isSearchStalled ? 'Loading ....' : ''}
  </form>
);

const CustomSearchBox = connectSearchBox(SearchBox);


const cover_arts = [
  'https://pixelsao.com/wp-content/uploads/2020/03/bass-anthology-preview.jpg',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQ-uPcuIvm8ssQZPR2KcnJe6BMwFQVE0tewg&usqp=CAU',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRO7QdkJrfJmJTz2tC-IcqzBTiNgojWTHL-lA&usqp=CAU',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSex70MTiFo7u4vHsOrwzaa4T7CbgD13RuI4g&usqp=CAU',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSavwhq1iyBU25xyVa9z_oYYpUcKuW6fuiuyg&usqp=CAU',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUb9tq9Irz16GAh_fCBdkBuiQPYw5M8neQBA&usqp=CAU',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-8RoUCCTeBVQ2F209JUYbJPvXrHOqK5v8JpE_u_8Oar-R-98EaBliLJ3rdLUsovJHTWg&usqp=CAU',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwGvRNP_h1fsdrNIEGb4M-DzIkMYL5NWFCPjo8OXdZQocwD8YCYz_4YHF6gNeZSoR0tI4&usqp=CAU'
]

function App() {

  const notify = () => toast("Song added!");

  // states
  const [audioInstance , setAudioInstance ] = useState(null);
  const [song, setSong] = useState(null);
  const [path, setPath] = useState('library');

  // redux
  const reducer = useSelector(state => state.reducer);

  // downloader
  const customDownloader = (downloadInfo) => {
    window.caches.open(downloadInfo.src).then(function(cache) {
      fetch(downloadInfo.src,{'mode':'no-cors'}).then(function(response) {
        return true;
      }).then(function(urls) {
        cache.add(urls)
        notify();
      });
    });
    dispatch(AddSong(reducer.library,song[0]));
  };

  const dispatch = useDispatch();

  const Hit = ({ hit }) => {
    return (
      <div className="search-result" style={{cursor:'pointer'}} onClick={() => {
        if (song) {
          audioInstance.clear();
          setSong([{
            'name': hit.title,
            'musicSrc': hit.link,
            'cover': cover_arts[Math.floor(Math.random() * cover_arts.length)],
            'singer': hit.artist,
          }]);
          audioInstance.updatePlayIndex(1000);
        } else {
          setSong([{
            'name': hit.title,
            'musicSrc': hit.link,
            'cover': cover_arts[Math.floor(Math.random() * cover_arts.length)],
            'singer': hit.artist,
          }]);
        }
      }}>
        <h4>{hit.title}</h4>
        <h6>{hit.artist}</h6>
      </div>
    );
  };

  return (
    <>

      <ToastContainer />

      { path === 'library'&&
        <>
          { reducer.library?.[0] ?
              <>
                <h1 className="text-center columns mt-5">Library</h1>
                <div className="text-center columns">
                  <Button variant="success" onClick={() => setSong([...reducer.library])}>Suffle</Button>
                </div>
                <br />
                <div className="mb100">
                {reducer.library.map((i) =>
                  <div className="card m-3 p-2">
                    <p className="h5" onClick={() => {
                      if (song) {
                        audioInstance.clear();
                        setSong([i]);
                        audioInstance.updatePlayIndex(1000);
                      } else {
                        setSong([i])
                      }
                    }}>
                      {i.name}
                    </p>
                    <button 
                      className="btn btn-outline-danger mt-4" style={{width:'40%',float:'right',flex:1,alignSelf:'flex-end'}} 
                      onClick={() => dispatch(RemoveSong(reducer.library,i))}
                    >
                      Delete
                    </button>
                  </div>
                )}
                </div>
              </>
            :
            <h3 className="text-center columns m-5">No Songs in library</h3>
          }
        </>
      }

      { song &&
        <ReactJkMusicPlayer
          getAudioInstance={(instance) => {
            setAudioInstance(instance);
          }}
          mode={'full'}
          showThemeSwitch
          theme={'auto'}
          autoPlay
          drag
          glassBg={false}
          audioLists={song}
          showPlayMode={false}
          showMiniProcessBar={true}
          showMiniModeCover={false}
          showReload={false}
          customDownloader={customDownloader}
        />
      }

      { path === 'search' &&
        <InstantSearch
          indexName="songs"
          searchClient={searchClient}
        >
          <CustomSearchBox />
          <div className="mb100">
            <Hits 
              hitComponent={Hit}
            />
          </div>
        </InstantSearch>
      }
      
      <div class="wrapper">
        <nav class="nav nav--icons">
          <ul>
            <li onClick={() => setPath('library')}>
              <a href="#news" className={path === 'library' ? 'is-active': 'is'}>
                <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                  <path fill="currentColor" d="M17 2h-10c-1.7 0-3 1.3-3 3v16c0 0.4 0.2 0.7 0.5 0.9s0.7 0.1 1-0.1l6.4-4.6 6.4 4.6c0.2 0.1 0.4 0.2 0.6 0.2s0.3 0 0.5-0.1c0.3-0.2 0.5-0.5 0.5-0.9v-16c0.1-1.7-1.2-3-2.9-3zM18 19.1l-5.4-3.9c-0.2-0.1-0.4-0.2-0.6-0.2s-0.4 0.1-0.6 0.2l-5.4 3.9v-14.1c0-0.6 0.4-1 1-1h10c0.6 0 1 0.4 1 1v14.1z"></path>
                </svg>
                <span>Library</span>
              </a>
            </li>
            <li onClick={() => setPath('search')}>
              <a href="#search" className={path === 'search' ? 'is-active': 'is'}>
                <svg class="icon icon-search" viewBox="0 0 24 24" width="24" height="24">
                  <path fill="currentColor" d="M21.7 20.3l-3.7-3.7c1.2-1.5 2-3.5 2-5.6 0-5-4-9-9-9s-9 4-9 9c0 5 4 9 9 9 2.1 0 4.1-0.7 5.6-2l3.7 3.7c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4zM4 11c0-3.9 3.1-7 7-7s7 3.1 7 7c0 1.9-0.8 3.7-2 4.9 0 0 0 0 0 0s0 0 0 0c-1.3 1.3-3 2-4.9 2-4 0.1-7.1-3-7.1-6.9z"></path>
                </svg>
                <span>Search</span>    
              </a>
            </li>
          </ul>
        </nav>
      </div>

    </>
  );
}

export default App;
